import { GenericObject, Media, copyFields, fixDates } from '@synergy/models';

import { Product } from '../../../common/models/product';
import { ProductSnapshot } from '../../../common/models/product-snapshot';
import { User } from '../../../common/models/user';

export class PurchaseItem extends ProductSnapshot {
    public id?: number;
    /** Documents and pictures filed on this position (#2187). */
    public media: Media[] = [];
    /** Order within the delivery address; the list sorts and moves by it (#2185). */
    public position = 0;
    public createdAt?: Date;
    public createdBy?: User;
    public updatedAt?: Date;
    public updatedBy?: User;

    public static fromPlainObject(object: GenericObject): PurchaseItem {
        const purchaseItem = new PurchaseItem();

        copyFields(object, purchaseItem);

        if (object['createdBy']) {
            purchaseItem.createdBy = User.fromPlainObject(object['createdBy']);
        }

        if (object['updatedBy']) {
            purchaseItem.updatedBy = User.fromPlainObject(object['updatedBy']);
        }

        if (object['product']) {
            purchaseItem.product = Product.fromPlainObject(object['product']);
        }

        fixDates(purchaseItem, ['createdAt', 'updatedAt']);

        return purchaseItem;
    }
}
